const German = {
  // MENU ITEMS
  routes: 'Routen',
  performance: 'Leistung',
  ships: 'Schiffe',
  fleet: 'Flotte',
  whatIsNew: 'Was ist neu',
  aboutCovadem: 'Über CoVadem',
  disclaimer: 'Disclaimer',
  selectLanguage: 'Sprache',
  signOut: 'Ausloggen',
  accountSettings: 'Account',
  covadem: 'CoVadem',

  // ROUTES
  today: 'Heute',
  stationName: 'Name Ort',
  waterLevel: 'Wasserstand',
  ruleOfThumb: 'Faustregel',
  latestUpdate: 'Letzte Aktualisierung',
  moreInformation: 'Weitere Informationen',
  lowestLoadingDepth: 'Niedrigste Ladetiefe',
  lowestRuleOfThumbLoadingDepth: 'Niedrigste FaustregelLadetiefe',
  lowestWaterDepth: 'Höchst verfügbare Wassertiefe',
  currentlyNotShowingDueToFiltering:
    ' wegen Filtereinstellungen nicht sichtbar',
  from: 'Von',
  to: 'Bis',
  passADate: 'Geben Sie ein Datum ein',
  showMap: 'Karte zeigen',
  bridges: 'Brücke',
  pegels: 'Pegel',
  lowestBridgeClearance: 'Niedrigste Brückenhöhe',
  type: 'Typ',
  KM: 'KM',
  name: 'Name',
  bridgeClearance: 'Höhe',
  tendency: 'Tendenz',
  routeStart: 'Route starten',
  routeEnd: 'Route beenden',
  loadingDepth: 'Ladetiefe',
  loadingDepthRuleOfThumb: 'Ladetiefe - Faustregel',
  squatTrim: 'squat/trim',
  extraSafetyMargin: 'Sicherheitsmarge',
  showAll: 'Alles anzeigen',
  noTableData: 'There is no Table Data',
  location: 'stelle',
  notAvailable: 'n.v.',
  sections: 'Abschnitte',
  showSelections: 'Auswahl anzeigen',
  both: 'Beide',
  searchNotFound: 'Keine Ergebnisse gefunden',
  locationSearchPlaceholder: 'Standort suchen',
  distance: 'Distanz',
  via: 'via',
  noRouteAvailable: 'Keine Route verfügbar',
  selectRoute: 'Wählen Sie eine Route',
  loading: 'Beladen',
  waterLevelRepresentsValueAt: 'Der Wasserstand stellt den Wert dar',

  // MAP
  showTable: 'Liste anzeigen',
  more: '...Mehr',
  draft: 'Tiefe',

  // MAP LEGEND
  shallow: 'Untiefe',
  deep: 'Tief',

  // PERFORMANCE
  emptySelection: 'Wählen Sie Ihre Einstellungen',
  clickReset: 'Klicken Sie auf die Schaltfläche: "Laden / zurück"',
  performanceOverallTitle: 'Allgemeine Informationen',
  showMyPerformance: 'Zeige meine Leistung',
  selectAPeriod: 'Zeitraum auswählen',
  selectADateAndTime: 'Datum und Uhrzeit auswählen',
  period: 'Zeitraum',
  minUKCThreshold: 'Grenzwert',
  minUKCThresholdCM: 'Grenzwert (CM)',
  culture: 'de',
  /* FIXME: this is currently not used, but maybe it will be in the future with logbooks */
  // dropDownData: [
  //   { id: 'minute', name: 'Minute' },
  //   { id: 'hour', name: 'Stunde' },
  //   { id: 'day', name: 'Tag' },
  //   { id: 'month', name: 'Monat' },
  //   { id: 'year', name: 'Jahr' },
  // ],
  export: 'Exportieren',
  exportStep1: 'Wählen Sie Einheiten',
  exportStep2: 'Exportieren',

  // PERF OVERVIEW
  // labels
  labels: {
    fuelFlowAverage: 'Durchschnittliche Kraftstoffverbrauch',
    speedAverage: 'Durchschnittsgeschwindigkeit',
    UKCAverage: 'Durchschnittliche Kielfreiheit',
    draftAverage: 'Durchschnittliche Tiefe',
    squatAverage: 'Durchschnittliche Squat',
    cargoWeightAverage: 'Durchschnittliche Cargo',
  },

  // perf. summary/overall
  distanceTotal: 'Zurückgelegte Strecke',
  fuelTotal: 'Gesamtkraftstoffverbrauch',
  co2Total: 'CO2-Gesamtemissionen',
  speedAverage: 'Durchschnittgeschwindigkeit',
  UKCAverage: 'Durchschnittliche Kielfreiheit',
  UKCMinimal: 'Kleinster beobachteter Kielabstand',
  cargoWeightAverage: 'Durchschnittsbeladung',

  fuelTKm: 'Kraftstoffverbrauch',
  csv: 'CSV',
  xlsx: 'XLSX (Excel)',

  co2TotalTooltip: `CoVadem berechnet die CO2-Emissionen basierend auf dem Tank-to-Wheel (TTW) CO2-Emissionsfaktor 
                    pro Liter fossilen Dieselkraftstoffs (2,657kg CO2/liter diesel), wie unter {0} zu finden. 
                    Wenn Ihr Schiff einen anderen Kraftstofftyp verwendet, gelten andere Emissionsfaktoren.`,

  // SHIPS
  ship: 'Schiff',
  box: 'CoVadem Box',
  boxType: 'CoVadem Boxtyp',
  boxNumber: 'CoVadem Box s/n',
  sensors: 'Sensoren',

  sensorTypeBox: 'Box',
  sensorTypeGPS: 'GPS',
  sensorTypeHDOP: 'HDOP',
  sensorTypeCargo: 'Ladung',
  sensorTypeEcho: 'Tiefenmesser',
  sensorTypeFuel: 'Kraftstoffverbrauchsmesser',

  shipData: 'Schiffsdetails',
  shipName: 'Schiffsname',
  ENINumber: 'ENI-Nummer',
  shipConstructionYear: 'Baujahr',
  shipLength: 'Länge',
  shipWidth: 'Breite',
  shipHeight: 'Höhe',
  shipWeight: 'Gewicht',
  shipMaxCargoWeight: 'Max Frachtgewicht',
  shipMaxDraft: 'Max Entwurf',

  sensorWorking: 'Funkzioniert',
  sensorWarning: 'Warnung',
  sensorError: 'Fehler',
  sensorUnavailable: 'Nicht verfügbar',

  // FLEET
  speed: 'Geschwindigkeit (km/h)',
  cargo: 'Ladung (tons)',
  tons: 'Tonnen',
  fuel: 'Kraftstoffverbrauch (l)',
  ukc: 'Kielfreiheit (m)',

  // ACCOUNT
  email: 'Email',
  fullName: 'Vollständiger Name',
  companyName: 'Name der Firma',
  signedUp: 'Angemeldet',
  noMeasuringShips: 'Keine Messschiffe',
  // ships: 'Ships',

  // NOTIFICATIONS
  errorOccurred: 'Ein Fehler ist aufgetreten',
  reloadPage: 'Bitte laden sie die Seite neu',
  anotherUserLoggedIn:
    'Sieht so aus, als wäre jemand mit Ihrem Konto bei einem anderen Gerät angemeldet',
  tokenExpired: 'Ihr Login-Token ist anscheinend abgelaufen',
  logInAgain: 'Ihr Login-Token ist anscheinend abgelaufen',
  appUpdatesMessage:
    'Die CoVadem-Plattform wurde aktualisiert und verbessert, bitte nutzen Sie den Link, um mehr zu erfahren.',
  errorMessage: 'Ein Fehler ist aufgetreten',
  offlineMessage:
    'Es gibt keine Internetverbindung, bitte überprüfen Sie Ihre Wifi- oder Mobilnetzeinstellungen.',
  moreInfoButton: 'more info',
  retry: 'wiederholen',
  announcementTitle: 'Störung',
  announcementMessage: `Wir bitten um Entschuldigung, die angezeigten Werte im Dashboard sind derzeit nicht so, wie Sie es vielleicht von uns erwarten. 
                        Dies ist auf eine Störung in unserem System zurückzuführen. Das Problem wurde behoben, aber es kann einige Tage dauern, 
                        bis alle Daten wiederhergestellt sind und das Dashboard wieder die richtigen Werte anzeigt.`,

  daysDurationLimit:
    'Der maximal zulässige Bereich liegt innerhalb von {0} Tagen.',

  // VALUES
  liter: 'Liter',
  ltr: 'Ltr',
  literAbbreviation: 'l',
  kilogram: 'Kilogramm',
  kilometer: 'Kilometer',
  km: 'Km',
  meter: 'Meter',
  meterAbbreviation: 'M',
  kilometerPerHour: 'Km/H',
  meterPerSecond: 'M/s',
  literPerHour: 'l/h',
  gramTonKilometer: 'g/t/km',
  literTonKilometer: 'l/t/km',

  // Export window
  expDateTimeDescription: 'Datum und Zeit(UTC)',
  expCountTotalDescription: 'Anzahl der Messungen',
  expGPSPathDescription: 'GeoJSON LineString (exklusiv für csv)',
  expDegrees: 'Grad (0 bis 360)',
  expGeoJsonPoint: 'Geojson Punkt',
  expLatLongSingle: '1 Spalte',
  expLatLongDouble: '2 Spalten',

  // OTHERS
  comingSoon: 'Kommt bald',
  show: 'Zeige',
  moreOpt: 'Einstellungen',
  dropDownPlaceholder: 'Wähle eine Option',
  dropDownSearchPlaceholder: 'Tippe um zu suchen',
  loadResetData: 'Laden / zurück',
  retryData: 'Wieder',
  cancel: 'Abbrechen',

  // PAGES
  aboutCovademContent:
    'Weitere Informationen finden Sie auf unserer Website unter',

  // UNSPECIFIED
  map: 'Karte',
  table: 'Liste',
  navbarRoute: 'Routen',
  navbarPerformance: 'Leistung',
  navbarShip: 'Schiffe',
  navbarMore: 'Mehr',
  languages: 'Sprachen',
  english: 'English',
  dutch: 'Nederlands',
  german: 'Deutsch',
  french: 'Français',
  startDateError: 'Startdatum ist erforderlich',
  endDateError: 'Enddatum ist erforderlich',
  periodError: 'Zeitraum ist erforderlich',
  selectedShipError: 'Bitte wählen Sie ein Schiff aus',
  noDataError: 'Für den ausgewählten Zeitraum sind keine Daten verfügbar',
  indicator: 'Trend',
  navNow: 'Jetzt',
  changePeriod: 'Bitte ändern Sie Ihre Einstellungen',
  navDay: 'Tag',
  navMonth: 'Monat',
  navYear: 'Jahr',
  days: 'Tage',
  routeDetailsButton: 'Routendetails anzeigen',
  loadingShips: 'Schiffe beladen...',
  selectShip: 'Wählen Sie Ihr Schiff aus',
  clickLogOut: 'Klicken Sie hier, um sich abzumelden',
  clickContinue: 'Klicken Sie hier um fortzufahren',
  backHome: 'Geh zurück nach hause',
  errorScreen: 'Fehlerbildschirm',
  dataSharing: 'Datenübertragung',
  showLowestWarnings: 'Kritische Punkte anzeigen',
  waterChartTitle: 'Wasserstandsunterschied',
  clearanceChartTitle: 'Durchfahrtshöhendifferenz der Brücke',
  chartError: 'Zur Zeit nicht verfügbar.',
  graphNow: 'Jetzt',
  graphDay: 't',
  unavailable: 'nicht verfügbar',
  basis: 'Basis',
  stuckedButton: 'Ich stecke fest, lade die Seite neu',
  ruleOfThumbAppliedWarningMessage:
    'Leider haben wir nicht genügend Messwerte, um eine genaue Position für die niedrigste Wassertiefe anzugeben.',

  // ADVERTISEMENT
  becomeMeasuringShipTitle: 'CoVadem bietet Vorteile für Messschiffe',
  becomeMeasuringShipWarn: `Sie verfügen nicht über ein Messschiff, deshalb können wir Ihnen auf dieser Seite keine Informationen anzeigen. 
                            Wussten Sie, dass Sie dadurch einen interessanten Rabatt verpassen? Der Rabatt kann bis zu 200 € betragen!`,
  becomeMeasuringShipSubTitle: 'Messen ist wissen',
  becomeMeasuringShipDescription: `Aber Messen wird nicht nur für CoVadem oder für einen Rabatt gemacht, denn: Messen ist Wissen! 
                                    Mit CoVadem können Sie die Leistung (z. B. Verbrauch, Last, zurückgelegte Strecke, Emissionen) über die Zeit überwachen. 
                                    Auf diese Weise generieren Sie wichtige Erkenntnisse, mit denen Sie Ihre Leistung kontinuierlich verbessern können. 
                                    Einblick, mit dem Sie auch die Auswirkung von Neuerungen 
                                    oder Änderungen auf die Schiffs- oder Betriebsführung überwachen können! 
                                    Darüber hinaus können Sie zur Qualität der Wassertiefeninformationen beitragen, die wir als CoVadem generieren.`,
  becomeMeasuringShipContact: `Sie möchten mehr darüber erfahren oder sich direkt als Messschiff registrieren? 
                                Dann kontaktieren Sie uns für die Möglichkeiten! 
                                Rufen Sie +31 88 2682300 an oder hinterlassen Sie Ihre Daten über { 0 } 
                                und wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen.`,
};

export default German;
